import React, { useState, useEffect } from 'react';
import './technologies.css';
import { motion } from 'framer-motion';

function C2wTechnologies({ isVisible }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const icons = [
    { name: 'javaLogoSvg', title: 'Java', style: { top: '20%', left: '10%', animationDelay: '0s' }, animation: 'float1' },
    { name: 'cLogoSvg', title: 'C', style: { top: '22%', left: '27%', animationDelay: '1.5s' }, animation: 'float2' },
    { name: 'pythonLogoSvg', title: 'Python', style: { top: '15%', left: '52%', animationDelay: '3s' }, animation: 'float3' },
    { name: 'cppLogoSvg', title: 'C++', style: { top: '27%', left: '70%', animationDelay: '0.8s' }, animation: 'float1' },
    { name: 'springLogoSvg', title: 'Spring Boot', style: { top: '18%', left: '84%', animationDelay: '2.2s' }, animation: 'float2' },
    { name: 'dsaLogoSvg', title: 'DSA', style: { top: '30%', left: '39%', animationDelay: '1.2s' }, animation: 'float3' },
    { name: 'iotLogoSvg', title: 'IoT', style: { top: '55%', left: '8%', animationDelay: '4s' }, animation: 'float1' },
    { name: 'dbmsLogoSvg', title: 'MySQL', style: { top: '52%', left: '88%', animationDelay: '2s' }, animation: 'float2' },
    { name: 'osLogoSvg', title: 'OS', style: { top: '73%', left: '17%', animationDelay: '0.5s' }, animation: 'float3' },
    { name: 'reactLogoSvg', title: 'React', style: { top: '65%', left: '34%', animationDelay: '3.5s' }, animation: 'float1' },
    { name: 'mlLogoSvg', title: 'AI/ML', style: { top: '72%', left: '54%', animationDelay: '1.7s' }, animation: 'float2' },
    { name: 'flutterSvg', title: 'Flutter', style: { top: '70%', left: '75%', animationDelay: '2.8s' }, animation: 'float3' }
  ];

  return (
    <div className="C2wTechnologies_ctn_redesign">
      {/* Central Heading */}
      <motion.div
        className="C2wTechnologies_heading_motion"
        initial={{ y: 30, opacity: 0 }}
        animate={isVisible ? { y: 0, opacity: 1 } : {}}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <div className="C2WTechnologies_heading">
          <h2 className="C2WTechnologies_heading_main">
            Know the <span className="C2wSpanCode">code</span> till the <span className="C2wSpanCore">core.</span>
          </h2>
          <p className="C2WTechnologies_heading_Submain">
            Build rock solid foundation of Programming
          </p>
        </div>
      </motion.div>

      {/* Floating Constellation Layout for Desktop */}
      {windowWidth > 768 ? (
        <div className="C2wTechnologies_floating_container">
          {icons.map((icon, idx) => (
            <motion.div
              key={idx}
              className={`C2wTechnologies_floating_icon ${icon.animation}`}
              style={icon.style}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={isVisible ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: idx * 0.08 + 0.3 }}
            >
              <div className="icon-wrapper">
                <img src={`/assets/images/landing/${icon.name}.svg`} alt={icon.title} />
              </div>
            </motion.div>
          ))}
        </div>
      ) : (
        /* Mobile Layout */
        <div className="C2wTechnologies_mobile_grid">
          {icons.map((icon, idx) => (
            <motion.div
              key={idx}
              className="C2wTechnologies_mobile_card"
              initial={{ opacity: 0, y: 30 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: idx * 0.05 }}
            >
              <div className="mobile-icon-img">
                <img src={`/assets/images/landing/${icon.name}.svg`} alt={icon.title} />
              </div>
              <span className="mobile-icon-title">{icon.title}</span>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}

export default C2wTechnologies;
